

import CustomerInvoiceTemplate from "./CustomerInvoice";

// 📌 **CustomerInvoiceTemplate** - قالب فاتورة العميل

// ✅ helper: اقرأ الخصم من localStorage
const readDiscountFromLS = (orderId) => {
  try {
    const raw = localStorage.getItem(`invoice_discount_${orderId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const discount = Number(parsed.discount || 0);
    const discount_ratio = Number(parsed.discount_ratio || 0);
    return {
      discount,
      discount_ratio,
      discount_is_percentage: discount_ratio > 0 ? 1 : 0,
    };
  } catch (e) {
    return null;
  }
};

// 📌 **handleBrowserPrint** - دالة طباعة الفاتورة عبر المتصفح
export const handleBrowserPrint = async (orderDetails, invoiceData, orderId) => {
  // ✅ 1) inject discount from localStorage قبل الطباعة
  const lsDiscount = readDiscountFromLS(orderId);

  const invoiceDataForPrint = {
    ...(invoiceData || {}),
    ...(lsDiscount
      ? {
          discount: lsDiscount.discount,
          discount_ratio: lsDiscount.discount_ratio,
          discount_is_percentage: lsDiscount.discount_is_percentage,
        }
      : {}),
  };

  const printWindow = window.open("", "printWindow", "width=400,height=600");
  if (!printWindow) {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return;
  }

  // ✅ 2) ابعت invoiceDataForPrint بدل invoiceData
  const html = await CustomerInvoiceTemplate(orderDetails, invoiceDataForPrint, orderId);

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();

  const tryClose = () => {
    try {
      if (printWindow && !printWindow.closed) printWindow.close();
    } catch (e) {}
  };

  printWindow.onafterprint = tryClose;
  try {
    printWindow.addEventListener &&
      printWindow.addEventListener("afterprint", tryClose);
  } catch (e) {}

  const fallbackTimer = setTimeout(() => tryClose(), 12000);

  const safePrint = async () => {
    try {
      if (printWindow.__waitForAssets) {
        await printWindow.__waitForAssets();
      } else {
        await new Promise((r) => setTimeout(r, 400));
      }
    } catch (e) {}

    try {
      printWindow.print();
    } catch (e) {
      console.error("❌ فشل أمر الطباعة", e);
    }
  };

  await safePrint();

  const pollInterval = setInterval(() => {
    if (!printWindow || printWindow.closed) {
      clearInterval(pollInterval);
      clearTimeout(fallbackTimer);
    }
  }, 500);
};
